export const CONTENT: Record<string, string> = {
  clean: 'Clean',
  explicit: 'Explicit',
};
